import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";

import { LoginService } from "./login.service";
import { isTeknikerContext } from "../util/tekniker-context";

@Injectable({ providedIn: "root" })
export class LogoutRedirectGuard implements CanActivate {
    constructor(
        private readonly router: Router,
        private readonly loginService: LoginService
    ) {}

    public canActivate(_: ActivatedRouteSnapshot, __: RouterStateSnapshot): boolean | UrlTree {
        // Ensure session is cleared before redirecting.
        this.loginService.logout();

        // Prefer explicit tekniker-context, fall back to last used login page.
        let lastLoginPage: string | null = null;
        try {
            lastLoginPage = localStorage.getItem("sidste-login-side");
        } catch {}

        const target = isTeknikerContext() || lastLoginPage === "tekniker" ? "tekniker-login" : "login";
        return this.router.parseUrl(target);
    }
}

